import React, { Component } from 'react';
import {
	Input
} from 'reactstrap';
import {connect} from "react-redux";
import {I18n} from '../../I18n/components/packageSelect';

class PackageSelect extends Component {
	constructor(props) {
		super(props)
		this.state = {
			value: ""
		}
	}

	onChangePackage = event => {
		const name = event.target.name;
		const value = event.target.value;
		this.setState({
			value
		});
		this.props.onChangePackage({name, value})
	};

	render() {
		const {lang} = this.props;
		const options = this.props.packages.map(item => <option value={item.id} key={item.id}>{item.name}</option>);
		if (this.props.view === 'packageSource') {
			return (
				<Input
					className="packageSource-select"
					type="select"
					name="packageSource"
					id="packageSource"
					onChange={this.onChangePackage}
					value={this.state.value}
				>
					<option value="">{I18n[lang].packSelect}</option>
					<option value="ALL">{I18n[lang].all}</option>
					{ options }
				</Input>
			)
		}
		return (
			<Input
				className="packageDestination-select"
				type="select"
				name="packageDestination"
				id="packageDestination"
				onChange={this.onChangePackage}
				value={this.state.value}
			>
				<option value="">{I18n[lang].packSelect}</option>
				{ options }
			</Input>
		)

	}
}

const mapDispatchToProps = dispatch => {
	return {
	};
};

const mapStateToProps = state => ({
	lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(PackageSelect)



// WEBPACK FOOTER //
// ./src/components/PackageManager/PackageSelect.js